__turbopack_context__.v({
  "progress": "UserProgressBar-module-scss-module__tFCtSW__progress",
});
